/* Momuna · "Encendé la pulsera" (18-10-2026)
   Entradas: movimiento del celular (DeviceMotion; en iPhone se pide permiso con un botón),
   arrastre con dedo/mouse sobre la escena y el botón "Encender" (teclado).
   Cada movimiento enciende el anillo de 12 luces en secuencia de colores, con intensidad
   según la fuerza; las estelas se dibujan en un canvas que solo corre mientras hay estelas vivas.
   Nada se inicializa hasta que el bloque entra en pantalla. Respeta prefers-reduced-motion. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('momuna-luz')) return;

  var COLORES = ['#FF6B57', '#FFD166', '#7ED36F', '#5EC8F2', '#8F86FF', '#F6A3C8'];
  var reducido = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  class MomunaLuz extends HTMLElement {
    connectedCallback() {
      if (this._listo) return;
      this._listo = true;
      var el = this;
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            el._visible = e.isIntersecting;
            if (e.isIntersecting && !el._iniciado) el.iniciar();
          });
        }, { rootMargin: '200px' });
        this._io.observe(this);
      } else { this._visible = true; this.iniciar(); }
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._mov) window.removeEventListener('devicemotion', this._mov);
    }

    iniciar() {
      this._iniciado = true;
      var el = this;
      this.escena = this.querySelector('[data-escena]');
      this.pulsera = this.querySelector('[data-pulsera]');
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas && this.canvas.getContext ? this.canvas.getContext('2d') : null;
      this.halos = Array.prototype.slice.call(this.querySelectorAll('.mm-luz__halo'));
      this.leds = Array.prototype.slice.call(this.querySelectorAll('.mm-luz__led'));
      this.contador = this.querySelector('[data-contador]');
      this.veces = 0;
      this.ultimo = 0;
      this.paso = 0;
      this.estelas = [];
      this.corriendo = false;

      // Personajes (ilustrativos: en la caja van surtidos)
      this.querySelectorAll('[data-pj-btn]').forEach(function (b) {
        b.addEventListener('click', function () { el.personaje(b.getAttribute('data-pj-btn'), true); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var bs = Array.prototype.slice.call(el.querySelectorAll('[data-pj-btn]'));
          var i = bs.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1);
          var n = bs[(i + bs.length) % bs.length]; n.focus(); n.click(); e.preventDefault();
        });
      });

      var enc = this.querySelector('[data-encender]');
      if (enc) enc.addEventListener('click', function () { el.encender(1, true); el.estallido(); });

      this.arrastre();
      this.movimiento();
      this.medir();
      window.addEventListener('resize', function () { el.medir(); }, { passive: true });
    }

    personaje(pj, encender) {
      this.setAttribute('data-personaje', pj);
      this.querySelectorAll('[data-pj-btn]').forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-pj-btn') === pj ? 'true' : 'false');
      });
      if (encender) this.encender(.7, true);
    }

    medir() {
      if (!this.canvas) return;
      var r = this.escena.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.w = r.width; this.h = r.height;
      this.canvas.width = Math.round(r.width * dpr);
      this.canvas.height = Math.round(r.height * dpr);
      if (this.ctx) this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    /* Enciende el anillo: cada luz toma un color y se prende en secuencia (Web Animations,
       solo opacidad y escala). fuerza 0..1 */
    encender(fuerza, contar) {
      var ahora = performance.now();
      fuerza = clamp(fuerza, .25, 1);
      if (!this.classList.contains('is-noche')) this.classList.add('is-noche');
      this.classList.add('is-usada');
      var base = this.paso++ % COLORES.length, dur = 700 + fuerza * 900, el = this;
      this.halos.forEach(function (h, i) {
        var c = COLORES[(base + Math.floor(i / 2)) % COLORES.length];
        h.style.color = c;
        el.leds[i].style.fill = c;
        if (reducido || !h.animate) { h.style.opacity = .85; return; }
        h.animate([
          { opacity: 0, transform: 'scale(.4)' },
          { opacity: .55 + fuerza * .45, transform: 'scale(' + (0.9 + fuerza * .5) + ')', offset: .18 },
          { opacity: 0, transform: 'scale(.6)' }
        ], { duration: dur, delay: i * (26 + (1 - fuerza) * 40), easing: 'ease-out', fill: 'none' });
      });
      // Los LEDs vuelven a blanco cuando termina la secuencia
      clearTimeout(this._apagar);
      this._apagar = setTimeout(function () {
        if (reducido) return;
        el.leds.forEach(function (l) { l.style.fill = ''; });
      }, dur + 12 * 60);

      if (!contar || ahora - this.ultimo < 650) return;
      this.ultimo = ahora;
      this.veces++;
      if (this.contador) this.contador.textContent = this.veces === 1 ? '¡Se encendió! Movela de nuevo.' : 'La encendiste ' + this.veces + ' veces.';
      if (this.veces === 1) {
        try { window.dispatchEvent(new CustomEvent('momuna:luz', { detail: { veces: 1 } })); } catch (e) {}
      }
      if (fuerza > .75 && navigator.vibrate && ahora - (this._vib || 0) > 900) { this._vib = ahora; try { navigator.vibrate(14); } catch (e) {} }
    }

    /* Estelas de luz en el canvas: puntos que se desvanecen en ~700 ms */
    estela(x, y, fuerza) {
      if (reducido || !this.ctx) return;
      this.estelas.push({ x: x, y: y, t: performance.now(), r: 6 + fuerza * 16, c: COLORES[this.paso % COLORES.length] });
      if (this.estelas.length > 90) this.estelas.splice(0, this.estelas.length - 90);
      if (!this.corriendo) { this.corriendo = true; requestAnimationFrame(this.dibujar.bind(this)); }
    }

    estallido() {
      var cx = this.w / 2, cy = this.h * .45, i, a;
      for (i = 0; i < 18; i++) {
        a = i / 18 * Math.PI * 2;
        this.estelas.push({ x: cx + Math.cos(a) * this.w * .3, y: cy + Math.sin(a) * this.w * .3, t: performance.now() + i * 12, r: 10, c: COLORES[i % COLORES.length] });
      }
      if (!reducido && this.ctx && !this.corriendo) { this.corriendo = true; requestAnimationFrame(this.dibujar.bind(this)); }
    }

    dibujar(ahora) {
      var ctx = this.ctx, vida = 720, vivos = [], i, e, k;
      ctx.clearRect(0, 0, this.w, this.h);
      if (!this._visible) { this.estelas = []; this.corriendo = false; return; }
      ctx.globalCompositeOperation = 'lighter';
      for (i = 0; i < this.estelas.length; i++) {
        e = this.estelas[i];
        k = 1 - (ahora - e.t) / vida;
        if (k <= 0) continue;
        if (k > 1) k = 1;
        vivos.push(e);
        var g = ctx.createRadialGradient(e.x, e.y, 0, e.x, e.y, e.r * (1.6 - k * .6));
        g.addColorStop(0, 'rgba(255,255,255,' + (k * .9) + ')');
        g.addColorStop(.35, hexA(e.c, k * .75));
        g.addColorStop(1, hexA(e.c, 0));
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(e.x, e.y, e.r * (1.6 - k * .6), 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
      this.estelas = vivos;
      if (vivos.length) requestAnimationFrame(this.dibujar.bind(this));
      else { this.corriendo = false; ctx.clearRect(0, 0, this.w, this.h); }
    }

    /* Arrastre: la pulsera se inclina hacia donde vas y vuelve con resorte al soltar */
    arrastre() {
      var el = this, esc = this.escena, abajo = false, lx = 0, ly = 0, lt = 0, id = null;
      function pos(e) { var r = esc.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
      esc.addEventListener('pointerdown', function (e) {
        abajo = true; id = e.pointerId;
        var p = pos(e); lx = p.x; ly = p.y; lt = performance.now();
        el.classList.add('is-arrastre');
        el.estela(p.x, p.y, .5);
      });
      esc.addEventListener('pointermove', function (e) {
        var p = pos(e), t = performance.now(), dt = Math.max(t - lt, 8);
        var vx = (p.x - lx) / dt, vy = (p.y - ly) / dt, v = Math.sqrt(vx * vx + vy * vy);
        // Con mouse sin apretar también deja estela (más suave); con dedo solo arrastrando
        if (!abajo && e.pointerType !== 'mouse') return;
        el.estela(p.x, p.y, clamp(v, 0, 1));
        if (abajo) {
          el.pulsera.style.setProperty('--px', clamp((p.x - el.w / 2) * .12, -26, 26) + 'px');
          el.pulsera.style.setProperty('--py', clamp((p.y - el.h / 2) * .08, -18, 18) + 'px');
          el.pulsera.style.setProperty('--rot', clamp(vx * 14, -16, 16) + 'deg');
        }
        if (v > .35 && t - (el._ultEnc || 0) > 260) { el._ultEnc = t; el.encender(clamp(v / 2.2, .3, 1), true); }
        lx = p.x; ly = p.y; lt = t;
      }, { passive: true });
      function soltar() {
        if (!abajo) return;
        abajo = false; id = null;
        el.classList.remove('is-arrastre');
        el.pulsera.style.setProperty('--px', '0px');
        el.pulsera.style.setProperty('--py', '0px');
        el.pulsera.style.setProperty('--rot', '0deg');
      }
      esc.addEventListener('pointerup', soltar);
      esc.addEventListener('pointercancel', soltar);
      esc.addEventListener('pointerleave', soltar);
    }

    /* Movimiento del celular. En iPhone hace falta un permiso explícito (botón). */
    movimiento() {
      var el = this, btn = this.querySelector('[data-movimiento]'), pista = this.querySelector('[data-pista-texto]');
      if (!('DeviceMotionEvent' in window)) return;
      var tactil = window.matchMedia && matchMedia('(pointer: coarse)').matches;
      if (!tactil) return;
      var ultimoG = null;
      this._mov = function (ev) {
        if (!el._visible) return;
        var a = ev.accelerationIncludingGravity || ev.acceleration;
        if (!a || a.x == null) return;
        if (!ultimoG) { ultimoG = { x: a.x, y: a.y, z: a.z }; return; }
        var dx = a.x - ultimoG.x, dy = a.y - ultimoG.y, dz = a.z - ultimoG.z;
        ultimoG = { x: a.x, y: a.y, z: a.z };
        var sacudida = Math.sqrt(dx * dx + dy * dy + dz * dz);
        // La pulsera acompaña la inclinación del celular
        el.pulsera.style.setProperty('--rot', clamp(-a.x * 2.2, -14, 14) + 'deg');
        var t = performance.now();
        if (sacudida > 4 && t - (el._ultMov || 0) > 220) {
          el._ultMov = t;
          var f = clamp((sacudida - 4) / 14, .3, 1);
          el.encender(f, true);
          el.estela(el.w / 2 + clamp(dx * 9, -el.w * .35, el.w * .35), el.h * .45 + clamp(dy * 9, -el.h * .3, el.h * .3), f);
        }
      };
      function escuchar() {
        window.addEventListener('devicemotion', el._mov, { passive: true });
        if (pista) pista.textContent = 'Mové el celular o arrastrá el dedo';
      }
      if (typeof DeviceMotionEvent.requestPermission === 'function') {
        // iPhone / iPad: botón explícito
        if (!btn) return;
        btn.hidden = false;
        btn.addEventListener('click', function () {
          DeviceMotionEvent.requestPermission().then(function (r) {
            if (r === 'granted') { btn.hidden = true; escuchar(); el.encender(1, true); el.estallido(); }
            else { btn.hidden = true; }
          }).catch(function () { btn.hidden = true; });
        });
      } else {
        escuchar();
      }
    }
  }

  function hexA(hex, a) {
    var n = parseInt(hex.slice(1), 16);
    return 'rgba(' + (n >> 16) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')';
  }

  customElements.define('momuna-luz', MomunaLuz);
})();
